import React from 'react';
import CookiePolicyNav from '../Components/CookiePolicy/CookiePolicyNav';
import CookiePolicyContent from '../Components/CookiePolicy/CookiePolicyContent';
import SEO from '../Components/SEO/SEO';
import Spacing from '../Components/Spacing/Spacing';
import { useLanguage } from '../contexts/LanguageContext';

const CookiePolicyPage = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <SEO
        title={t('cookies.meta.title')}
        description={t('cookies.meta.description')}
        image="/images/logo.svg"
      />
      <Spacing lg={120} md={80} />
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <CookiePolicyNav />
          </div>
          <div className="col-lg-9 col-md-8">
            <CookiePolicyContent />
          </div>
        </div>
      </div>
      <Spacing lg={120} md={80} />
    </>
  );
};

export default CookiePolicyPage;
